import { useMemo } from 'react';

import { createStateSelectorHook } from 'src/lib/sweetState';
import { MultiPromptTemplatesStore } from 'src/store';

const useMultiPromptTemplatesState = createStateSelectorHook(MultiPromptTemplatesStore, [
  'multiPromptBriefExtractionResult',
]);

export const useMultiPromptBriefExtractionResult = (chainId) => {
  const { multiPromptBriefExtractionResult } = useMultiPromptTemplatesState();

  return useMemo(() => {
    if (!chainId || !multiPromptBriefExtractionResult) {
      return null;
    }

    return multiPromptBriefExtractionResult[chainId];
  }, [chainId, multiPromptBriefExtractionResult]);
};
